<div class="cit2-page-heading-stepper">
  <div class="container">
    <div class="row">
      <div
        class="col-12 d-flex flex-row justify-content-between align-items-md-center"
      >
        <div class="stepper mb-0">
          <div class="stepper-container">
            <button
              *ngFor="let value of steps; index as i"
              [ngClass]="{
                active: i === currentStep,
                checked: i < currentStep,
                '': i > currentStep
              }"
              class="automation-{{ value.title }}"
              (click)="goToStep(i)"
              tabindex="{{ i + 1 <= currentStep ? 0 : null }}"
              [attr.aria-label]=""
            >
              <div class="circle-graphic">
                <div class="gb-body2">
                  <small *ngIf="i >= currentStep">{{ i + 1 }}</small>
                </div>
              </div>
              <div class="title">
                <div class="gb-body2">
                  <small>
                    <p class="step-title" [translate]="value.title"></p>
                  </small>
                </div>
              </div>
            </button>
          </div>
        </div>
        <div
          class="gb-body3 automation-{{
            returnState.text
          }} d-flex align-items-center"
        >
          <a
            [translate]="returnState.text"
            (click)="goToReturnState()"
            class="heavy"
            [attr.aria-label]="'stepper_heading_returnState_label' | translate"
            href="javascript:void(0);"
          ></a>
        </div>
      </div>
    </div>
  </div>
</div>
